export default "__VITE_ASSET__BQYT02bU__"